import type { IconData } from '@stacksjs/iconify-core'

export const invisible1Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.232 1.232a2.5 2.5 0 0 1 3.536 0l7.437 7.438A23.4 23.4 0 0 1 24 5.5c10.798 0 19.89 7.28 22.645 17.198a4.87 4.87 0 0 1 0 2.604a23.5 23.5 0 0 1-6.776 11.031l6.899 6.9a2.5 2.5 0 0 1-3.536 3.535l-42-42a2.5 2.5 0 0 1 0-3.536m18.42 14.885l12.231 12.23a9.004 9.004 0 0 0-12.23-12.23M6.124 13.746a23.45 23.45 0 0 0-4.769 8.952a4.87 4.87 0 0 0 0 2.605C4.11 35.22 13.203 42.5 24 42.5c3.214 0 6.277-.645 9.066-1.812z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default invisible1Solid
